export default "__VITE_ASSET__BiQEw10z__"